import React, { useEffect, useState } from 'react';
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ItemMaster } from '../../../../services/apiTypes';
import { defaultItem } from '../../hooks/useItem';
import { MaxLength } from '../../../../_constants/maxLengthConst';

type EditItemLabelModalProps = {
  item: ItemMaster;
  isOpen: boolean;
  handleSave: (data: ItemMaster) => void;
  handleCancel: () => void;
};

const EditItemLabelModal: React.FC<EditItemLabelModalProps> = ({
  item,
  isOpen,
  handleSave,
  handleCancel,
}) => {
  const { t } = useTranslation();
  const [editItemNames, setEditItemNames] = useState<ItemMaster>(defaultItem);

  useEffect(() => {
    if (item || isOpen) {
      setEditItemNames(item);
    }
  }, [item, isOpen]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    const fieldName = name as keyof ItemMaster;
    setEditItemNames({ ...editItemNames, [fieldName]: value });
  };

  /** ダイアログを閉じるときに実行する処理 */
  const closeModal = (isClose: boolean) => {
    if (isClose === true) {
      handleCancel();
    }
  };

  return (
    <Dialog open={isOpen} onClose={closeModal}>
      <Box display="flex">
        <DialogTitle>{t('LBL_EDIT')}</DialogTitle>
      </Box>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={t('LBL_ITEM_NAME_LANG', { 0: t('LBL_LANG_EN') })}
          type="text"
          fullWidth
          name="itemName"
          value={editItemNames.itemName}
          onChange={handleInputChange}
          slotProps={{
            htmlInput: {
              maxLength: MaxLength.ManageInspectionItem.ITEM_NAME,
            },
          }}
        />
        <TextField
          margin="dense"
          label={t('LBL_ITEM_NAME_LANG', { 0: t('LBL_LANG_JA') })}
          type="text"
          fullWidth
          name="itemNameJp"
          value={editItemNames.itemNameJp}
          onChange={handleInputChange}
          slotProps={{
            htmlInput: {
              maxLength: MaxLength.ManageInspectionItem.ITEM_NAME,
            },
          }}
        />
        <TextField
          margin="dense"
          label={t('LBL_ITEM_NAME_LANG', { 0: t('lang3') })}
          type="text"
          fullWidth
          name="itemName03"
          value={editItemNames.itemName03}
          onChange={handleInputChange}
          slotProps={{
            htmlInput: {
              maxLength: MaxLength.ManageInspectionItem.ITEM_NAME,
            },
          }}
        />
        <TextField
          margin="dense"
          label={t('LBL_ITEM_NAME_LANG', { 0: t('lang4') })}
          type="text"
          fullWidth
          name="itemName04"
          value={editItemNames.itemName04}
          onChange={handleInputChange}
          slotProps={{
            htmlInput: {
              maxLength: MaxLength.ManageInspectionItem.ITEM_NAME,
            },
          }}
        />
        <TextField
          margin="dense"
          label={t('LBL_ITEM_NAME_LANG', { 0: t('lang5') })}
          type="text"
          fullWidth
          name="itemName05"
          value={editItemNames.itemName05}
          onChange={handleInputChange}
          slotProps={{
            htmlInput: {
              maxLength: MaxLength.ManageInspectionItem.ITEM_NAME,
            },
          }}
        />
        <TextField
          margin="dense"
          label={t('LBL_ITEM_NAME_LANG', { 0: t('lang6') })}
          type="text"
          fullWidth
          name="itemName06"
          value={editItemNames.itemName06}
          onChange={handleInputChange}
          slotProps={{
            htmlInput: {
              maxLength: MaxLength.ManageInspectionItem.ITEM_NAME,
            },
          }}
        />
        <TextField
          margin="dense"
          label={t('LBL_ITEM_NAME_LANG', { 0: t('lang7') })}
          type="text"
          fullWidth
          name="itemName07"
          value={editItemNames.itemName07}
          onChange={handleInputChange}
          slotProps={{
            htmlInput: {
              maxLength: MaxLength.ManageInspectionItem.ITEM_NAME,
            },
          }}
        />
        <TextField
          margin="dense"
          label={t('LBL_ITEM_NAME_LANG', { 0: t('lang8') })}
          type="text"
          fullWidth
          name="itemName08"
          value={editItemNames.itemName08}
          onChange={handleInputChange}
          slotProps={{
            htmlInput: {
              maxLength: MaxLength.ManageInspectionItem.ITEM_NAME,
            },
          }}
        />
        <TextField
          margin="dense"
          label={t('LBL_ITEM_NAME_LANG', { 0: t('lang9') })}
          type="text"
          fullWidth
          name="itemName09"
          value={editItemNames.itemName09}
          onChange={handleInputChange}
          slotProps={{
            htmlInput: {
              maxLength: MaxLength.ManageInspectionItem.ITEM_NAME,
            },
          }}
        />
        <TextField
          margin="dense"
          label={t('LBL_ITEM_NAME_LANG', { 0: t('lang10') })}
          type="text"
          fullWidth
          name="itemName10"
          value={editItemNames.itemName10}
          onChange={handleInputChange}
          slotProps={{
            htmlInput: {
              maxLength: MaxLength.ManageInspectionItem.ITEM_NAME,
            },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => closeModal(true)}
          color="inherit"
          variant="contained"
          sx={{ width: '120px', mr: 2, my: 1 }}
        >
          {t('BTN_CANCEL')}
        </Button>
        <Button
          onClick={() => handleSave(editItemNames)}
          color="primary"
          variant="contained"
          sx={{ width: '120px', mr: 3, my: 1 }}
        >
          {t('BTN_SAVE')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditItemLabelModal;
